import { z } from 'zod';
import { TIPOS_DOCUMENTO } from './cliente';
export const EmpleadoSchema = z.object({
    id: z.string().uuid(),
    tipo: z.string(),
    tipoDocumento: z.string(),
    nroDocumento: z.string(),
    nombre: z.string(),
    apellido: z.string(),
    email: z.string().nullable().optional(),
    telefono: z.string().nullable().optional(),
    fechaAlta: z.string(),
    fechaBaja: z.string().nullable().optional(),
    uusuarioId: z.string().uuid().nullable().optional(),
    cuil: z.string().nullable().optional(),
    frecuenciaLiquidacion: z.string().nullable().optional(),
    comisionSolicitadoPctOverride: z
        .union([z.string(), z.number()])
        .nullable()
        .optional(),
    comisionSolicitadoMontoOverride: z
        .union([z.string(), z.number()])
        .nullable()
        .optional(),
    activo: z.boolean(),
    creadoEn: z.string(),
    actualizadoEn: z.string(),
});
export const EmpleadoFormSchema = z.object({
    tipo: z.string().trim().min(1, 'Requerido').max(50),
    tipoDocumento: z.enum(TIPOS_DOCUMENTO),
    nroDocumento: z.string().trim().min(1, 'Requerido').max(50),
    nombre: z.string().trim().min(1, 'Requerido').max(100),
    apellido: z.string().trim().min(1, 'Requerido').max(100),
    email: z.string().trim().email('Email inválido').max(150).optional().or(z.literal('')),
    telefono: z.string().trim().max(50).optional().or(z.literal('')),
    fechaAlta: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Formato YYYY-MM-DD'),
    fechaBaja: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/, 'Formato YYYY-MM-DD')
        .optional()
        .or(z.literal('')),
    cuil: z
        .string()
        .trim()
        .regex(/^\d{2}-\d{7,8}-\d$/, 'Formato XX-XXXXXXXX-X')
        .optional()
        .or(z.literal('')),
    frecuenciaLiquidacion: z.string().optional().or(z.literal('')),
    comisionSolicitadoPctOverride: z.string().optional().or(z.literal('')),
    comisionSolicitadoMontoOverride: z.string().optional().or(z.literal('')),
});
const PaginacionSchema = z.object({
    total: z.number(),
    pagina: z.number(),
    porPagina: z.number(),
    totalPaginas: z.number(),
});
export const EmpleadosPaginadosSchema = z.object({
    items: z.array(EmpleadoSchema),
    paginacion: PaginacionSchema,
});
// --------------- Habilitaciones ---------------
export const HabilitacionSchema = z.object({
    id: z.string().uuid(),
    empleadoId: z.string().uuid(),
    nivelId: z.number(),
    nivelNombre: z.string(),
    disciplinaClave: z.string(),
    fechaInicio: z.string(),
    fechaFin: z.string().nullable().optional(),
    observaciones: z.string().nullable().optional(),
    vigente: z.boolean(),
});
export const HabilitacionFormSchema = z.object({
    nivelId: z.coerce.number().int().min(1, 'Seleccioná un nivel'),
    fechaInicio: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Formato YYYY-MM-DD'),
    observaciones: z.string().max(2000).optional().or(z.literal('')),
});
// --------------- Disciplina / Nivel ---------------
export const DisciplinaSchema = z.object({
    id: z.number().optional(),
    clave: z.string(),
    nombre: z.string().optional(),
    activo: z.boolean().optional(),
});
export const NivelSchema = z.object({
    id: z.number(),
    nombre: z.string(),
    disciplina: z.string().optional(),
    orden: z.number().optional(),
    activo: z.boolean().optional(),
});
